module.exports = __webpack_public_path__ + "static/clean-air-30074a18868f47dde58e5807e28cb659.png";